module.exports = __webpack_public_path__ + "static/media/bank.9fe17e9d.png";